import { I18nConfig } from '../i18n';

export type BuildConfig = {
  appId: string;
  i18n: I18nConfig;
};
